import React, { createContext, useContext, useState } from 'react'
import CryptoJS from 'crypto-js'

const AuthContext = createContext()
const secKey = process.env.REACT_APP_SECRET_TOKEN

export const AuthProvider = ({ children }) => {
  const [isLogin, setIsLogin] = useState(false)

  const login = async() => {
    let expirationTime = new Date().getTime() + (60 * 60 * 1000) // 1 hour from now
    let encryptedData = CryptoJS.AES.encrypt(JSON.stringify(expirationTime), secKey).toString()
    localStorage.setItem("ttk", encryptedData)
    setIsLogin(true)
  }

  const checkLogin = async() => {
    let checkData = localStorage.getItem("ttk")
    if(checkData) {
      try {
        let decryptedData = CryptoJS.AES.decrypt(checkData, secKey).toString(CryptoJS.enc.Utf8);
        if(!decryptedData) {
          logout()
          return
        }
        let expirationTime = JSON.parse(decryptedData)
        if(expirationTime > new Date().getTime()) {
          setIsLogin(true)
        } else {
          logout()
        }
      } catch(error) {
        // If decryption fails (malformed data), clear and logout
        logout()
      }
    }
  }

  const logout = () => {
    localStorage.clear()
    setIsLogin(false)
  }

  return (
    <AuthContext.Provider value={{ isLogin, login, checkLogin, logout }}>
      {children}
    </AuthContext.Provider>
  )
}

export function useAuth() {
  return useContext(AuthContext)
}